module.exports = __webpack_public_path__ + "img/MN.ff8cc931.svg";